import { uniqueId } from "@/views/zhiji/js/common/util.js";

// 数据概览-客户端格式转服务端
function cvtDataOverviewParam(reqData) {
    return {
        language: reqData.lang && reqData.lang != "all" ? reqData.lang : "",
        channel: reqData.channel && reqData.channel != "all" ? reqData.channel : "",
        start_time: reqData.startTime,
        end_time: reqData.endTime
    };
}

// 数据概览-服务端格式转客户端
function transDataOverview(result) {
    return {
        visitedCount: result.pv.toLocaleString("en-US"), // 访问次数
        userCount: result.uv.toLocaleString("en-US"), // 访问人数
        questionsNum: result.question_num.toLocaleString("en-US"), // 提问量
        identifyQuesRate: result.identify_question_rate, // 问题识别率
        robotInterceptRate: result.robot_intercept_rate, // 机器人拦截率
        likeRate: result.like_rate, // 满意度
        inputQuestionNum: result.input_question_num, // 手动提问量
        inputQuestionRate: result.input_question_rate, // 手动提问量占比
        questionToUserRate: result.question_to_user_rate // 人均对话量
    };
}

//机器人监控：数据概览-服务端格式转客户端
function cvtRobotOverview(result) {
    return {
        visitedCount: result.pv.toLocaleString("en-US"), // 访问次数
        userCount: result.uv.toLocaleString("en-US"), // 访问人数
        questionsNum: result.question_count.toLocaleString("en-US"), // 提问量
        identifyQuesRate: result.input_question_rate, // 输入提问占比
        robotInterceptRate: result.robot_intercept_rate, // 机器人拦截率
    };
}

// 数据趋势-客户端格式转服务端
function cvtDataTrendParam(reqData) {
    return {
        language: reqData.lang && reqData.lang != "all" ? reqData.lang : "",
        channel: reqData.channel && reqData.channel != "all" ? reqData.channel : "",
        page: reqData.page || "",
        size: reqData.size || "",
        start_time: reqData.startTime,
        end_time: reqData.endTime,
        type: reqData.type
    };
}

// 数据趋势-服务端格式转客户端
function transDataTrend() {
    return {
        chartData: transDataTrendChart,
        robotData: transRobotData,
        labourData: transLabourData,
        robotTrendData: transRobotTrendData
    };
}

// 处理数据趋势
function transDataTrendChart(result) {
    let ret = defaultTrendData();

    let xAxisArr = Object.keys(result);
    xAxisArr.sort((a, b) => {
        return new Date(a) - new Date(b);
    });

    for (let index in xAxisArr) {
        for (let i in result) {
            if (xAxisArr[index] == i) {
                ret.xAxisData.push(xAxisArr[index]);
                ret.visitCount.push(result[i].pv);
                ret.userCount.push(result[i].uv);
                ret.questionNum.push(result[i].question_num);
                ret.questionUser.push(result[i].question_user);
                ret.inputQuesNum.push(result[i].input_question_num);
                ret.inputQuesUser.push(result[i].input_question_user);
                break;
            }
        }
    }
    return ret;
}

//机器人监控：数据趋势
function transRobotTrendData(result) {
    let ret = defaultTrendData();
    if(result.list) {
        for(let hours in result.list) {
            ret.xAxisData.push(hours); // x轴数据
            ret.visitCount.push(result.list[hours].pv);//访问次数
            ret.userCount.push(result.list[hours].uv);//访问人数
            ret.questionNum.push(result.list[hours].question_count);// 提问量
            ret.questionUser.push(result.list[hours].question_user_count);//提问人数
            ret.inputQuesNum.push(result.list[hours].input_question_count);//输入提问量
            ret.inputQuesUser.push(result.list[hours].input_question_user_count);//输入提问人数
        }
    }
    return ret
}

function defaultTrendData() {
    return {
        xAxisData: [],
        visitCount: [], // 访问次数
        userCount: [], // 访问人数
        questionNum: [], // 提问量
        questionUser: [], // 提问人数
        inputQuesNum: [], // 输入提问量
        inputQuesUser: [] // 输入提问人数
    }
}

// 处理数据详情
function transRobotData(result) {
    let list = result.list.map(data => {
        return {
            rowId: uniqueId(),
            date: data.idate, // 日期
            visitTimes: data.pv, // 访问次数
            visitCount: data.uv, // 访问人数
            questionsNum: data.question_num, // 提问量
            questionCount: data.question_user, // 提问人数
            enterQuesNum: data.input_question_num, // 输入提问量
            inputQuesRate: data.input_question_rate, // 输入提问占比
            inputQuesCount: data.input_question_user, // 输入提问人数
            replyRate: data.identify_question_rate, // 问题识别率
            satisfaction: data.like_rate, // 满意度
            retentionRate: data.retention_rate, // 次留
            questionToUserRate: data.question_to_user_rate //人均对话量
        };
    });

    return {
        count: result.count,
        list: list
    };
}

function transLabourData(result) {
    let list = result.list.map(data => {
        return {
            date: data.idate, // 日期
            sessionNum: data.session_num, // 会话量
            ticketNum: data.ticket_session_num, // 提交工单会话量
            ticketRate: data.ticket_session_rate, // 提交工单会话率
            artificialNum: data.artificial_session_num, // 转人工会话量
            artificialRate: data.artificial_session_rate, // 转人工会话率
            interceptRate: data.robot_intercept_rate // 机器人拦截率
        };
    });

    return {
        count: result.count,
        list: list
    };
}

export default {
    cvtDataOverviewParam,
    transDataOverview,
    cvtDataTrendParam,
    transDataTrend,
    cvtRobotOverview
};
